module.exports = __webpack_public_path__ + "img/No_Annual_Fee_Icon.75eaa369.png";